<template>
    <div>
        <p v-if="empty">
            {{ $t('resources.no-resource') }}
        </p>
        <ul class="list-group list-group-flush list" v-else>
            <li class="list-group-item px-0"
                v-for="resource in filteredResources" :key="resource.id"
            >
                <div class="row">
                    <div class="col-sm-9">
                        <h4 class="mb-0 font-weight-normal">
                            <a :href="resource.url" target="_blank">
                                {{ resource.name }}
                            </a>
                        </h4>
                    </div>
                    <div class="col-sm-3 text-right">
                        <a :href="resource.url" target="_blank">
                            <base-button type="primary" size="sm">
                                {{ $t('common.open') }}
                            </base-button>
                        </a>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'

    export default {  

        props: {

            registration: {
                type: Object,
            },
        },

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/resources',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    query: {
                        filters: { degree_id: this.registration.degree.id },
                        sort: ['position'],
                    }
                }),
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        computed: {

            empty() {
                return this.filteredResources.length == 0
            },

            filteredResources() {
                return this.ctrl.rows.filter(resource => {
                    return !resource.confidential || this.$permissions.hasRight('dashboard.confidential-resources.read')
                })
            }
        },

        methods: {
            
            mapData(resource) {
                return resource
            },

            unmapData(data) {
                return data
            }
        }
    }
</script>

<style scoped>

    ul {
        border-top: 1px solid rgba(0, 0, 0, 0.05);
    }

</style>

